var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`top-bar`},[_c('div',{staticClass:"bar-content"},[_c('div',{staticClass:"logo",on:{"click":_vm.handleLogoClick}},[(_vm.iconShow === 'snack')?_c('img',{attrs:{"src":require("./imgs/snack.png"),"alt":""}}):_c('img',{attrs:{"src":require("./imgs/kwai.png"),"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }